import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from } from "rxjs";
import { eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})

export class MarketplaceService {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.MarketplaceProxy);
        // this.contractsService.getContractIstances(eContracts.MarketplaceProxy).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.MarketplaceProxy);
    }

    createOrder1155(ownerAddress: string, nftAddress: string, assetId: string, amount: number, priceInWei: string,
        paymentToken: string, expiresAt: string): Observable<any> {
        return from(this.contract.createOrder1155(nftAddress, assetId, amount, priceInWei, paymentToken, expiresAt)
            .send({ from: ownerAddress }));
    }

    cancelOrder1155(ownerAddress: string, nftAddress: string, assetId: string): Observable<any> {
        return from(this.contract.methods.cancelOrder1155(nftAddress, assetId)
            .send({ from: ownerAddress }));
    }

}

@Injectable({
    providedIn: 'root'
})

export class MarketplaceBidService {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.ERC721Bid);
        // this.contractsService.getContractIstances(eContracts.ERC721Bid).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.ERC721Bid);
    }
}